module.exports = { "default": require("core-js/library/fn/map"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/map.js
// module id = 544
// module chunks = 168707334958949